export interface Marker {
    name: 'new'|string,
    symbol: string,
    size: number,
    color: string,
}

const fieldSeparator = ';';
const markersSeparator = '|';

export const markerToString = (value: Marker): string => 
    `${value.name.replace(fieldSeparator, '')}${fieldSeparator}${value.size}${fieldSeparator}${value.symbol}${fieldSeparator}${value.color}`;

export const parseMarker = (valueStr: string):Marker|null => {
    const vals = valueStr.split(fieldSeparator);
    return !vals || vals.length !== 4 ? null : {
        name: vals[0],
        size: parseInt(vals[1]),
        symbol: vals[2],
        color: vals[3],
    };
}

export const parseMarkers = (valuesStr: string): Marker[] => valuesStr.split(markersSeparator).filter(v => v).map(str => parseMarker(str)).filter(v => v) as Marker[];